/* Pattern styles */
import "./pattern.scss";

wp.domReady(() => {
    // Start Front-End Javascript
    // Set height of slider
    const banner = document.querySelectorAll(".banner");

    banner.forEach((element) => {
        const bannerSlides = element.querySelectorAll(".wp-swiper__slide");
        const bannerHeight =
            element.querySelector(".general-text").offsetHeight * 2;

        bannerSlides.forEach((slide) => {
            slide.style.height = `${bannerHeight}px`;
        });
    });
});
